import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DocumentMaster} from '../models/document-master';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DocumentInfo} from '../models/document-info';

@Component({
  selector: 'document-attach-form',
  template: `
    <div class="attach-section">
      <div *ngIf="!docInfo.fileId && !uploading">
        <button class="btn btn-primary btn-sm btn-upload btn-block">Choose File</button>
        <input id="file-upload" type="file" width="50px" (change)="fileChange($event)"/>
      </div>
      <div *ngIf="uploading">
        <div class="progress progress-warning">
          <div class="progress-bar" 
               role="progressbar" 
               [ngStyle]="{'width': progress + '%'}"
               aria-valuemin="0" 
               aria-valuemax="100"></div>
        </div>
        <div class="text-center alert alert-warning">Processing</div>
      </div>
      <div *ngIf="docInfo.fileId">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-2x fa-check green-check"></i>
          </div>
          <div class="col-md-10">
            {{docInfo.filename}}
          </div>
        </div>
        <div class="text-center alert alert-success">Ready for Upload</div>
      </div>
    </div>
    <form (ngSubmit)="attach()">
      <div class="attach-section">
        <input class="form-control form-control-sm"
               placeholder="Name"
               [ngModel]="docInfo.title"
               [formControl]="documentForm.controls['title']"/>
      </div>
      <div class="attach-section">
          <textarea class="form-control form-control-sm"
                    rows="2"
                    placeholder="Description"
                    [ngModel]="docInfo.description"
                    [formControl]="documentForm.controls['description']"></textarea>
      </div>
      <div class="text-right">
          <button class="btn btn-outline-primary btn-sm" [disabled]="!docInfo.fileId">
            <span>Upload File</span>
          </button>
          <a class="btn btn-outline-danger btn-sm" (click)="clearFile()">Clear Form</a>
      </div>
    </form>
  `,
  styles: [`
    .attach-section {
      margin-bottom:5px;
    }
    .btn-upload {
      margin-bottom:-25px;
      position:relative;
      pointer-events: none;
    }
    input[type=file] {
      max-width:100%;
    }
    .green-check {
      color:green;
      left:100%;
    }
    .progress {
      border:1px solid #666;
    }
    .alert {
      padding-top: 0;
      padding-bottom: 0;
    }
  `]
})
export class DocumentAttachFormComponent {

  @Input() docInfo: DocumentMaster;
  @Input() uploading: boolean;
  @Input() progress: number;
  @Output() uploadFile: EventEmitter<DocumentInfo> = new EventEmitter();
  @Output() saveMetaData: EventEmitter<DocumentMaster> = new EventEmitter();
  @Output() resetFileUpload: EventEmitter<null> = new EventEmitter();
  public documentForm: FormGroup;

  constructor(fb: FormBuilder) {
    this.documentForm = fb.group({
      'title': [null],
      'description': [null]
    });
  }

  attach() {
    const rtrn = Object.assign({}, this.docInfo);
    if (!this.documentForm.controls['title'].value) {
      rtrn.title = rtrn.filename;
    } else {
      rtrn.title = this.documentForm.controls['title'].value;
    }

    rtrn.description = this.documentForm.controls['description'].value;
    this.saveMetaData.emit(rtrn);
    this.documentForm.reset();
  }

  fileChange(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const doc = new DocumentInfo(0, file.name, file.name.substr(file.name.lastIndexOf('.') + 1), file.type, file);
      this.uploadFile.emit(doc);
    }
  }

  clearFile() {
    this.resetFileUpload.emit();
    this.documentForm.reset();
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/components/document-attach-form.ts